import { vesselScheduleApis } from '@apis/dashboard/vesselScheduleApis';
import { VesselScheduleQuery } from '@models/VesselSchedule';
import { useInfiniteQuery } from '@tanstack/react-query';

export const useInfiniteVesselSchedules = (query: VesselScheduleQuery, enabled?: boolean) => {
  return useInfiniteQuery(
    ['/dashboard/vessel-schedule/?infinite', query],
    async ({ pageParam = 1 }) => {
      const r = await vesselScheduleApis.get('/dashboard/vessel-schedule/', {
        query: {
          ...query,
          page: pageParam,
        },
      });
      return r[200]!;
    },
    {
      enabled,
      getNextPageParam: (lastPage, pages) =>
        lastPage.next !== null ? pages.length + 1 : undefined,
    },
  );
};
